import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { getContentPromotions } from '@/app/components/search/components/Card/utils/getContentPromotions.tsx';
import type { Feature } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';

export const getPromotionFeatures = ({
  hasPromotionTypes,
  promotionTypes,
  t,
  imageBasePath,
  searchParams,
}: GetFeaturesInnerParams): Feature[] => {
  if (!hasPromotionTypes) return [];

  return getContentPromotions({ promotionTypes, t, imageBasePath, searchParams }) || [];
};
